export default __webpack_public_path__ + "static/media/07_photo.57c9b717.jpg";